<template>
  <div class="builder__actions" :class="responsiveCssClasses">
    <div v-if="this.initialQueryString" class="builder__reset">
      <button type="button" @click="$emit('reset-options-to-initial-query-string')">Reset</button>
    </div>
    <div class="builder__clear">
      <button type="button" @click="$emit('clear-options')">Clear</button>
    </div>
    <div class="builder__download">
      <a :href="downloadImageLink" rel="nofollow noindex">Download</a>
    </div>
    <!--
    <div class="builder__save">
      <button type="button" @click="$emit('add-to-comparison-gallery')" :disabled="isSubmitting">Save & Compare</button>
    </div>
    -->
    <div v-if="!this.isSoldOut" class="builder__add">
      <button type="button" @click="$emit('add-to-cart')" :disabled="isSubmitting">Add to Cart</button>
    </div>
  </div>
</template>

<script>
  //todo: implement shareLink somehow

  export default {
    name: 'builder-actions',
    props: ['initialQueryString', 'isSoldOut', 'isWidescreen', 'isSubmitting', 'shareLink', 'downloadImageLink'],
    data() {
      return {
        responsiveCssClasses: {
          'builder__actions--tablet-landscape-and-larger': this.isWidescreen,
          'builder__actions--tablet-portrait-and-smaller': !this.isWidescreen,
        },
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Actions.vue?25a1e491